import { makeStyles } from 'tss-react/mui';
import { GRAY_ALTERNATIVE } from "src/global/theme/colors";

export const styles = makeStyles()(() => {
  return {
    mainContent: {
      width: '100%',
      height: '100%',
      backgroundColor: GRAY_ALTERNATIVE,
    },
  };
});
